export default {
    isAuth: !!localStorage.getItem('qbo_token')
}